import { render, staticRenderFns } from "./DistributionListMembers.vue?vue&type=template&id=27ae43bc&"
import script from "./DistributionListMembers.vue?vue&type=script&lang=js&"
export * from "./DistributionListMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports